import React from "react";
import { HiOutlineDownload, HiOutlineExternalLink } from "react-icons/hi";
import Section from "./Section";
import Reveal from "./Reveal";
import cv from "../Assets/Ahmed-Saleem-Khan-CV.pdf";

function Resume() {
  return (
    <Section id="resume" title="My" accent="CV">
      <Reveal className="card resume-card">
        <p>The full, latest CV — summary, skills, experience, projects and education.</p>
        <div className="hero-actions">
          <a className="btn btn-primary" href={cv} download="Ahmed-Saleem-CV.pdf"><HiOutlineDownload /> Download PDF</a>
          <a className="btn btn-ghost" href={cv} target="_blank" rel="noreferrer"><HiOutlineExternalLink /> View in browser</a>
        </div>
        <object data={cv} type="application/pdf" className="pdf-frame" aria-label="CV preview">
          <p className="muted">Your browser can't preview PDFs — use the buttons above.</p>
        </object>
      </Reveal>
    </Section>
  );
}

export default Resume;
